import { Component } from '@angular/core';

@Component({
	selector: 'seira-legenda-mapa-grafico-relatorio',
	templateUrl: './legenda-mapa-grafico-relatorio.component.html.component.html',
	styleUrls: ['./legenda-mapa-grafico-relatorio.component.html.component.scss'],
})
export class LegendaMapaGraficoRelatorioComponentHtmlComponent {}
